import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoader = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "eZWJSsUkyuV1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 260 260",
	preserveAspectRatio: "xMinYMid slice",
	shapeRendering: "geometricPrecision",
	textRendering: "geometricPrecision",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		mask: "url(#eZWJSsUkyuV24)",
		children: [/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsxs("g", {
			mask: "url(#eZWJSsUkyuV15)",
			children: [/* @__PURE__ */ _jsx("g", {
				transform: "translate(.000001 0)",
				children: /* @__PURE__ */ _jsxs("g", {
					mask: "url(#eZWJSsUkyuV13)",
					children: [/* @__PURE__ */ _jsx("ellipse", {
						id: "eZWJSsUkyuV12",
						style: { mixBlendMode: "exclusion" },
						rx: 130.771084,
						ry: 130.771084,
						transform: "matrix(.83 0 0 0.83 129.7 130)",
						fill: "none",
						stroke: "#fff",
						strokeWidth: 50
					}), /* @__PURE__ */ _jsx("mask", {
						id: "eZWJSsUkyuV13",
						"mask-type": "luminance",
						x: "-150%",
						y: "-150%",
						height: "400%",
						width: "400%",
						children: /* @__PURE__ */ _jsx("ellipse", {
							id: "eZWJSsUkyuV14",
							style: {
								mixBlendMode: "exclusion",
								isolation: "isolate"
							},
							rx: 215.593391,
							ry: 215.591583,
							transform: "matrix(.834905 0 0 0.834912 302.7 130)",
							fill: "none",
							stroke: "#fff",
							strokeWidth: 50
						})
					})]
				})
			}), /* @__PURE__ */ _jsx("mask", {
				id: "eZWJSsUkyuV15",
				"mask-type": "luminance",
				x: "-150%",
				y: "-150%",
				height: "400%",
				width: "400%",
				children: /* @__PURE__ */ _jsx("g", {
					transform: "translate(.000001 0)",
					children: /* @__PURE__ */ _jsxs("g", {
						mask: "url(#eZWJSsUkyuV19)",
						children: [/* @__PURE__ */ _jsx("ellipse", {
							id: "eZWJSsUkyuV18",
							style: {
								mixBlendMode: "exclusion",
								isolation: "isolate"
							},
							rx: 215.593391,
							ry: 215.591583,
							transform: "matrix(.834905 0 0 0.834912 302.7 130)",
							fill: "none",
							stroke: "#fff",
							strokeWidth: 50
						}), /* @__PURE__ */ _jsx("mask", {
							id: "eZWJSsUkyuV19",
							"mask-type": "luminance",
							x: "-150%",
							y: "-150%",
							height: "400%",
							width: "400%",
							children: /* @__PURE__ */ _jsx("ellipse", {
								id: "eZWJSsUkyuV20",
								style: { mixBlendMode: "difference" },
								rx: 130.771084,
								ry: 130.771084,
								transform: "matrix(.83 0 0 0.83 129.7 130)",
								fill: "none",
								stroke: "#fff",
								strokeWidth: 50
							})
						})]
					})
				})
			})]
		}), /* @__PURE__ */ _jsxs("g", {
			transform: "translate(.000001 0)",
			children: [/* @__PURE__ */ _jsx("ellipse", {
				id: "eZWJSsUkyuV22",
				style: { mixBlendMode: "exclusion" },
				rx: 130.771084,
				ry: 130.771084,
				transform: "matrix(.83 0 0 0.83 129.7 130)",
				fill: "none",
				stroke: "#000",
				strokeWidth: 50
			}), /* @__PURE__ */ _jsx("ellipse", {
				id: "eZWJSsUkyuV23",
				style: {
					mixBlendMode: "exclusion",
					isolation: "isolate"
				},
				rx: 215.593391,
				ry: 215.591583,
				transform: "matrix(.834905 0 0 0.834912 302.7 130)",
				fill: "none",
				stroke: "#000",
				strokeWidth: 50
			})]
		})] }) }) }), /* @__PURE__ */ _jsx("mask", {
			id: "eZWJSsUkyuV24",
			"mask-type": "luminance",
			x: "-150%",
			y: "-150%",
			height: "400%",
			width: "400%",
			children: /* @__PURE__ */ _jsx("ellipse", {
				rx: 129.5,
				ry: 129,
				transform: "translate(129 130)",
				fill: "#d2dbed",
				strokeWidth: 0
			})
		})]
	})
});
export default SvgLoader;
